import React, { CSSProperties, FunctionComponent, MutableRefObject, useRef } from 'react'

import { arrow, flip, offset, shift, useFloating } from '@floating-ui/react-dom'

import { ShowMoreText } from '@/components/show-more-text'
import { Color } from '@/styles'

import { Arrow, Popper } from './styled-tooltip'

interface Props {
  targetRef: MutableRefObject<HTMLElement | null>
  isVisible: boolean
  title: string
  placement?: 'right' | 'left' | 'bottom' | 'top'
}

const Tooltip: FunctionComponent<Props> = ({ targetRef, isVisible, title, placement = 'right' }) => {
  const arrowRef = useRef<HTMLDivElement>(null)

  const {
    refs,
    floatingStyles,
    placement: finalPlacement,
    middlewareData,
  } = useFloating({
    placement,
    strategy: 'fixed',
    elements: {
      reference: targetRef.current,
    },
    middleware: [offset(10), shift(), flip(), arrow({ element: arrowRef })],
  })

  if (!isVisible) return null

  const side = finalPlacement.split('-')[0] as 'top' | 'right' | 'bottom' | 'left'
  const staticSide = { top: 'bottom', right: 'left', bottom: 'top', left: 'right' }[side] as string

  const arrowStyles: CSSProperties = {
    left: middlewareData.arrow?.x != null ? `${middlewareData.arrow.x}px` : '',
    top: middlewareData.arrow?.y != null ? `${middlewareData.arrow.y}px` : '',
    [staticSide]: '-6px',
  }

  return (
    <Popper ref={refs.setFloating} style={floatingStyles}>
      <Arrow ref={arrowRef} style={arrowStyles} data-placement={finalPlacement} />
      <ShowMoreText text={title} maxChar={3000} textColor={Color.WHITE} />
    </Popper>
  )
}

export default Tooltip
